export default __webpack_public_path__ + "static/lilnadas-cards-health-3-4c72d3def3d8deea12185876c6241dec.png";